module.exports = __webpack_public_path__ + "static/fonts/NanumGothic-ExtraBold.e8d3c62.woff2";